import React from 'react'

function Laptop({ className }) {
  return (
    <svg
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon--laptop${className ? ' ' + className : ''}`}
    >
      <path d="M0 0h48v48h-48z" fill="none" />
      <path d="M40 36v-2c2.21 0 3.98-1.79 3.98-4l.02-20c0-2.21-1.79-4-4-4h-32c-2.21 0-4 1.79-4 4v20c0 2.21 1.79 4 4 4v2h-8v4h48v-4h-8zm-32-26h32v20h-32v-20z" />
    </svg>
  )
}

export default Laptop
